import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from 'react-accessible-accordion';
import { AddOutlined, RemoveOutlined } from '@mui/icons-material';

export function AccordionGroup({ children }) {
  return (
    <Accordion allowZeroExpanded allowMultipleExpanded>
      {children}
    </Accordion>
  );
}

AccordionGroup.propTypes = {
  children: PropTypes.node,
};

function StatePageAccordion({ heading, children }) {
  return (
    <AccordionItem className='border-b-[1px] border-base-content text-base-content first:border-t-[1px]'>
      <AccordionItemHeading>
        <AccordionItemButton className='flex justify-between py-7'>
          <h3 className='m-0 text-lg'>{heading}</h3>
          <AccordionItemState>
            {({ expanded }) =>
              expanded ? <RemoveOutlined /> : <AddOutlined />
            }
          </AccordionItemState>
        </AccordionItemButton>
      </AccordionItemHeading>
      <AccordionItemPanel className='space-y-7 pb-7 pr-7 [&>div]:space-y-7 [&_ol]:last:mb-0 [&_p]:last:mb-0 [&_pre]:bg-inherit [&_pre]:py-0 [&_ul]:last:mb-0'>
        {children}
      </AccordionItemPanel>
    </AccordionItem>
  );
}

StatePageAccordion.propTypes = {
  heading: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default StatePageAccordion;
